import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
};

export const useSessionDateFormat = () => {
  const { i18n } = useTranslation();

  return useCallback(
    (dateString: string | undefined): string => {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return date.toLocaleDateString(
        i18n.language.startsWith('en') ? 'en-US' : 'ja-JP',
        DATE_OPTIONS,
      );
    },
    [i18n.language],
  );
};
